<template>
  <div class="index-container">
    <div class="good flex-between-start">
      <div class="picture flex-center-center">
        <!-- :style="{
          background: 'url(' + info.coverPicture + ') no-repeat center center',
          'background-size': '100% 100%'
        }" -->
        <!-- <img src="../../assets/images/icon/open-icon.png" class="open" alt="" /> -->

        <el-image v-if="nftType == 'img'" :src="info.picture + parameters" :preview-src-list="[`${info.picture}${parameters}`]">
        </el-image>
        <model-obj class="phone" v-if="nftType == '3d'" :width="300" :height="300" :src="info.picture + parameters">
        </model-obj>
        <model-obj class="PC" v-if="nftType == '3d'" :width="528" :height="594" :src="info.picture + parameters">
        </model-obj>

        <video-player class="video-player vjs-custom-skin" v-if="nftType == 'video' || nftType == 'audio'"
          ref="videoPlayer" :playsinline="true" :options="playerOptions"></video-player>

      </div>
      <div class="info">
        <div class="name-div flex-between-center">
          <p class="name">{{ info.nftName }}</p>
          <el-popover placement="bottom" width="130" trigger="click">
            <div class="share-div">
              <p class="item" @click="copyLink">复制链接</p>
              <p class="item" @click="changeShareDialogVisible">生成海报</p>
            </div>
            <img slot="reference" src="../../assets/images/icon/share-icon.png" class="share" alt="分享" />
          </el-popover>
        </div>

        <div class="isCopy" v-if="info.isCopy === 1">
          <p>
            编号：#{{ info.nftNumberVO.nftNo
            }}<span v-if="!info.levelId">/{{ info.quantity }}</span>
          </p>
          <p class="check-number" v-if="info.isCopy === 1" @click="getNumber">
            选择藏品编号
          </p>
        </div>
        <div class="look flex-between-center">
          <div v-if="info.isExchange && !info.nftNumberVO.consignmentNo" class="left flex-start-center">
            <img src="../../assets/images/gift.png" alt="礼物" />
            <span>可以领取实物赠品</span>
          </div>
          <div class="right flex-start-start">
            <p class="price">
              当前价格<span class="price-icon">¥</span>
              <span class="price-num">{{ info.nftNumberVO.price }}</span>
            </p>
            <!-- <div class="item"> -->
            <!-- <img src="../../assets/images/icon/look-icon.png" alt="" />
              <span>12345</span> -->
            <!-- </div> -->
            <!-- <div class="item"> -->
            <!-- <img src="../../assets/images/icon/collect-num-icon.png" alt="" />
              <span>12345</span> -->
            <!-- </div> -->
          </div>
        </div>
        <div class="owner flex-between-center">
          <div class="left flex-between-center">
            <div class="product item flex-start-start" @click="
              routeClick('/creator', {
                userId: info.nftNumberVO.ownerId,
                userType: info.nftNumberVO.ownerUserType
              })
            ">
              <img :src="info.nftNumberVO.headPortrait ? info.nftNumberVO.headPortrait + parametersHead : headImg"
                alt="头像" />
              <div>
                <p>藏家</p>
                <p>{{ info.nftNumberVO.ownerUserName }}</p>
              </div>
            </div>
            <div class="album item flex-start-start" @click="routeClick('/portfolioInfo', { worksId: info.worksId })">
              <img :src="info.mark ? info.mark + parametersHead : headImg" alt="头像" />
              <div>
                <p>藏品集</p>
                <p>{{ info.collectionName }}</p>
              </div>
            </div>
          </div>
          <div class="price">
            <p>
              当前价格<span class="price-icon">¥</span><span class="price-num">{{ info.nftNumberVO.price }}</span>
            </p>
          </div>
        </div>
        <div class="platform flex-around-center">
          <div class="item flex-between-center">
            <span>网络平台</span>
            <div class="cun flex-start-center">
              <img src="../../assets/images/cun-logo.png" alt="" class="logo" />
              <span>CUN</span>
            </div>
          </div>
          <div class="item flex-between-center">
            <span>网络地址</span>
            <div class="flex-start-start">
              <span class="address" @click="scanClick(info.nftNumberVO.txHash)">{{ spanOmit(info.nftNumberVO.txHash)
              }}</span>
              <img src="../../assets/images/icon/copy-icon.png" alt="复制" class="copy" @click="copyAddress" />
            </div>
          </div>
          <div class="item flex-between-center">
            <span>ID</span>
            <div class="flex-start-start">
              <span>{{
                  info.nftNumberVO ? info.nftNumberVO.tokenId : ""
              }}</span>
              <img src="../../assets/images/icon/copy-icon.png" alt="复制" class="copy" @click="copyNumber" />
            </div>
          </div>
          <div class="item flex-between-center">
            <span>存储</span>
            <div class="flex-start-start">
              <span>IPFS</span>
            </div>
          </div>
          <div class="item flex-between-center">
            <span>铸造平台</span>
            <div class="flex-start-start">
              <span>女娲NVWA</span>
            </div>
          </div>
          <!-- <div class="item">
            <span>元数据</span>
            <div>
              <span>{{ info.txHash }}</span>
            </div>
          </div> -->
          <div class="item flex-between-center">
            <span>铸造时间</span>
            <div class="flex-start-start">
              <span>{{ info.createTime }}</span>
            </div>
          </div>
        </div>
        <div class="pay flex-between-center" v-if="info.nftType != 2 || info.nftNumberVO.consignmentNo">
          <div class="type flex-start-center">
            <span>支付方式：</span>
            <!-- <div class="flex-start-center">
              <img
                src="../../assets/images/icon/zfbpay-icon.jpg"
                style="width: 30px; margin-right: 10px"
                class="pay-icon"
                alt="支付宝"
              />
              <span style="font-size: 16px; color: #707070">支付宝支付</span>
            </div> -->
            <el-select :id="'payType' + '-' + payType" v-model="payType"
              style="width: 50%;border:1px solid rgba(235, 235, 235, 1);" placeholder="请选择">
              <el-option :class="'payType' + item.value" v-for="item in directionOption" :key="item.value"
                :label="item.label" :disabled="item.disabled" :value="item.value">
                <!-- <img style="width:12px"  :src="item.img" > -->
                <!-- <span>{{item.label}}</span> -->
              </el-option>
            </el-select>
            <!-- <el-select v-model="value" placeholder="请选择">
              <el-option :key="0" label="微信支付" value="1">
                <div class="flex-start-center">
                  <img
                    src="../../assets/images/icon/wechatpay-icon.jpg"
                    style="width: 30px; margin-right: 10px"
                    class="pay-icon"
                    alt=""
                  />
                  <span style="font-size: 16px; color: #707070">微信支付</span>
                </div>
              </el-option>
              <el-option :key="1" label="支付宝支付" value="2">
                <div class="flex-start-center">
                  <img
                    src="../../assets/images/icon/zfbpay-icon.jpg"
                    style="width: 30px; margin-right: 10px"
                    class="pay-icon"
                    alt=""
                  />
                  <span style="font-size: 16px; color: #707070">支付宝支付</span>
                </div>
              </el-option>
            </el-select> -->
          </div>

          <div v-if="
            info.auditStatus === 2 &&
            info.nftNumberVO &&
            info.nftNumberVO.sellStatus === 0
          " class="pay-div">

            <span class="price-icon">¥ <span class="price-num">{{ info.nftNumberVO.price }}</span></span>
            <input v-if="!buyTime || buyTime <= systemTime || payType === '1' || info.nftNumberVO.consignmentNo"
              type="button" value="立即购买" class="pay-btn" @click="pay" />
            <div v-else class="pay-other">
              <span class="djs">发售倒计时</span>
              <button class="pay-btn pay-btn-cancel">
                <span v-if="d > 0">{{ d + "天" }}</span>
                {{ h > 9 ? h : "0" + h }}:{{ m > 9 ? m : "0" + m }}:{{
                    s > 9 ? s : "0" + s
                }}
              </button>
            </div>
          </div>
          <div v-else-if="info.auditStatus === 4" class="pay-div">
            <input type="button" value="已下架" class="pay-btn pay-btn-false" />
          </div>
          <div v-else class="pay-div">
            <span class="price-icon">¥ <span class="price-num">{{ info.price }}</span></span>
            <input type="button" :value="info.nftNumberVO.statusName" class="pay-btn pay-btn-false" />
          </div>
        </div>
        <div class="pay flex-between-center" v-else-if="info.nftNumberVO.sellStatus != 2 && info.nftType == 2">
          <div class="type"></div>
          <div class="pay-div">
            <input type="button" value="去合成" class="pay-btn" @click="compose" />
          </div>
        </div>
        <div class="pay flex-between-center" v-else-if="info.nftNumberVO.sellStatus == 2">
          <div class="type"></div>
          <div class="pay-div">
            <input type="button" :value="info.nftNumberVO.statusName" class="pay-btn pay-btn-false" @click="compose" />
          </div>
        </div>
      </div>
    </div>
    <div class="info">
      <p class="title">藏品详情</p>
      <div class="dis" v-html="info.nftDesc"></div>
    </div>
    <infoRemindComponent></infoRemindComponent>
    <!-- <blindBoxAboutComponent v-if="info.levelId"></blindBoxAboutComponent> -->
    <historyComponent :detail="info"></historyComponent>
    <!-- <div class="hotgoods">
      <div class="title flex-between-center">
        <p>热门商品</p>
        <i class="el-icon-arrow-up"></i>
      </div>
      <div class="goods flex-start-start"> -->
    <!-- <template v-for="(v, k) in hotData" :key="k">
          <market-component :production-data="v"></market-component>
        </template> -->
    <!-- </div>
    </div> -->
    <input id="input" type="" style="position: absolute; opacity: 0" />
    <el-dialog class="number-dialog number-dialog-pc" title="" :visible.sync="dialogVisible" width="1000px"
      :before-close="handleClose">
      <div>
        <span class="title">藏品列表</span>
        <div class="condition">
          <div class="left">
            <el-input placeholder="请输入藏品编号" suffix-icon="el-icon-search" @input="e => (nftNo = isnumber(e))"
              @blur="getNumberList()" v-model="nftNo">
            </el-input>
          </div>
          <div class="right flex-start-center">
            <el-select v-model="condition" @change="getNumberList()" placeholder="请选择" :popper-append-to-body="false">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <div class="sort">
              <span class="item" :class="conSort == 1 ? 'active' : ''" @click="sortChange(1)">按编号排序</span>
              <span class="item " :class="conSort == 2 ? 'active' : ''" @click="sortChange(2)">按价格排序</span>
            </div>
          </div>
          <!-- <el-checkbox
            v-model="onSell"
            v-if="info.nftType != 2"
            @change="getNumberList"
            >仅看在售藏品</el-checkbox
          > -->
        </div>
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="nftNo" label="藏品编号"> </el-table-column>
          <el-table-column prop="nftName" label="藏品名称"> </el-table-column>
          <el-table-column prop="tokenId" label="ID"> </el-table-column>
          <el-table-column prop="price" label="售价"> </el-table-column>
          <el-table-column prop="statusName" label="状态">
            <template slot-scope="scope">
              <span class="selling"
                v-if="scope.row.statusName == '在售' || scope.row.statusName == '盲盒在售'">{{ scope.row.statusName }}</span>
              <span class="selling red-span" v-else-if="scope.row.statusName == '挂售'">{{ scope.row.statusName }}</span>
              <span class="selling purple-span" v-else-if="scope.row.statusName == '可合成'">{{ scope.row.statusName }}</span>
              <span class="selling grey-span" v-else>{{ scope.row.statusName }}</span>
            </template>

          </el-table-column>
          <el-table-column prop="date" label="详情">
            <template slot-scope="scope">
              <span class="show" @click="infoClick(scope.row)">查看</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" :page-size="pageSize" @prev-click="prevClick" @next-click="nextClick"
          @current-change="currentChange" :total="totalCount">
        </el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button> -->
      </span>
    </el-dialog>
    <el-dialog class="number-dialog number-dialog-phone" title="" :visible.sync="dialogVisible" width="100%"
      :before-close="handleClose">
      <div>
        <span class="title">藏品列表</span>
        <div class="condition">
          <div class="left">
            <el-input placeholder="请输入藏品编号" suffix-icon="el-icon-search" type="number"
              @input="e => (nftNo = isnumber(e))" @blur="getNumberList()" v-model="nftNo">
            </el-input>
          </div>
          <div class="right flex-between-center">
            <el-select v-model="condition" placeholder="请选择" @change="getNumberList()" :popper-append-to-body="false">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <div class="sort">
              <span class="item" :class="conSort == 1 ? 'active' : ''" @click="sortChange(1)">按编号排序</span>
              <span class="item " :class="conSort == 2 ? 'active' : ''" @click="sortChange(2)">按价格排序</span>
            </div>
          </div>

        </div>
        <div class="table">
          <div class="item flex-between-center" v-for="(v, k) in tableData" :key="k" @click="infoClick(v)">
            <div class="left">
              <div>
                <span>#{{ v.nftNo }}/{{ info.quantity }}</span>
                <span class="selling" v-if="v.statusName == '在售' || v.statusName == '盲盒在售'">{{ v.statusName }}</span>
                <span class="selling red-span" v-else-if="v.statusName == '挂售'">{{ v.statusName }}</span>
                <span class="selling purple-span" v-else-if="v.statusName == '可合成'">{{ v.statusName }}</span>
                <span class="selling grey-span" v-else>{{ v.statusName }}</span>
              </div>
              <div>
                <span>ID：{{ v.tokenId }}</span>
              </div>
            </div>
            <div class="right">
              <div class="">
                <span>¥{{ v.price }}</span>
                <span>></span>
              </div>
            </div>
          </div>
        </div>
        <el-pagination layout="prev, pager, next" :page-size="pageSize" @prev-click="prevClick" @next-click="nextClick"
          @current-change="currentChange" :total="totalCount">
        </el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button> -->
      </span>
    </el-dialog>

    <shareComponent :info="info" :shareDialogVisible="shareDialogVisible"
      @changeShareDialogVisible="changeShareDialogVisible"></shareComponent>
  </div>
</template>

<script>
import {
  marketDetail,
  marketList,
  getSysTime,
  nftNumberList,
  marketDetailNum,
  shopCardListWithMe
} from '../../request/api.js'
import {
  getDicType,
  timeChange,
  decode,
  ossParameters,
  ossParameters1,
  encode
} from '../../assets/js/globle.js'
import headImg from '../../assets/images/head.png'
import zfbIcon from '../../assets/images/icon/zfbpay-icon.jpg'
// import * as THREE from 'three'
// import Stats from 'three/examples/jsm/libs/stats.module.js'
// import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader.js'
// import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader.js'
// import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
// import useClipboard from 'vue-clipboard3'
// import VamVideo from 'vue-vam-video'
import { ModelObj } from 'vue-3d-model'
import shareComponent from '../../conponents/share/index.vue'
import historyComponent from '../../conponents/history/index.vue'
import blindBoxAboutComponent from '../../conponents/blindBoxAbout/index.vue'
import infoRemindComponent from '../../conponents/infoRemind/index.vue'
import { Decimal } from 'decimal.js'
// console.log(ModelObj)
export default {
  components: {
    ModelObj,
    shareComponent,
    historyComponent,
    blindBoxAboutComponent,
    infoRemindComponent
  },

  data() {
    return {
      numSort: true,
      priceSort: false,
      payType: '4',
      condition: '1',
      conSort: '1',
      parameters: ossParameters(),
      parametersHead: ossParameters1(),
      options: [{
        value: '',
        label: '全部'
      }, {
        value: '1',
        label: '仅看在售藏品'
      }, {
        value: '2',
        label: '仅看挂售藏品'
      }],
      directionOption: [
        // {
        //   value: '3',
        //   label: '绑卡支付',
        //   disabled: false
        // },

        {
          img: zfbIcon,
          value: '4',
          label: '购物卡支付',
          disabled: false
        },
        {
          img: zfbIcon,
          value: '2',
          label: '快捷支付',
          disabled: false
        },
        {
          img: zfbIcon,
          value: '1',
          label: '选购码支付',
          disabled: false
        }
        // {
        //   img: zfbIcon,
        //   value: '0',
        //   label: '支付宝支付',
        //   disabled: false
        // }
      ],
      playerOptions: {
        // playbackRates: [ 0.5, 1.0, 1.5, 2.0 ], // 可选择的播放速度
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: '',
            src: '' // url地址
          }
        ],
        poster: '', // 你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true // 全屏按钮
        }
      },
      dialogVisible: false,
      shareDialogVisible: false,
      tableData: [],
      videoOption: {
        properties: {
          poster: '',
          src: '',
          preload: 'auto'
          // loop: "loop",
          // autoplay:"autoplay",
          // muted:true
        },
        videoStyle: {
          // width: "1200px",
          // height: "600px",
        },
        controlsConfig: {
          fullScreenTit: '全屏',
          EscfullScreenTit: '退出全屏',
          speedTit: '倍速',
          yinliangTit: '音量',
          jingyinTit: '静音',
          playTit: '播放',
          pauseTit: '暂停',
          fullScreen: true,
          speed: true,
          listen: true
        }
      },
      asdf: 'asdf',
      msg: 'This is webGL',
      renderer: null,
      camera: null,
      scene: null,
      light: null,
      stats: null,
      controls: null,
      canvasDiv: {
        element: null,
        wigth: '',
        height: ''
      },
      mesh: null,
      objChildren: [],
      mousePosition: {
        mouseX: 0,
        mouseY: 0
      },
      raycaster: null,
      mouse: null,
      selectObj: null,
      timer: null,
      animationRenId: null,
      animationAniId: null,

      headImg: headImg,
      centerDialogVisible: true,
      nftType: 'img',
      info: {
        auditStatus: '',
        contractAddress: '',
        categoryName: '',
        isExchange: '',
        nftDesc: '',
        nftId: '',
        nftName: '',
        ownerId: '',
        picture: '',
        price: '',
        quantity: '',
        recommendType: '',
        reviewer: '',
        userId: '',
        userType: '',
        worksId: '',
        receipt: {},
        isCopy: 0,
        nftNumberVO: {}
      },
      text: '',

      value: '',
      hotData: [],
      systemTime: '',
      buyTime: '',
      d: '',
      h: '',
      m: '',
      s: '',

      onSell: true,
      nftNo: '',
      totalCount: 0,
      pageNo: 1,
      pageSize: 10,
      meShopCardList: {}
    }
  },
  watch: {
    // 监听路由发生改变
    $route: {
      handler(newVal) {
        this.init()
      }
    }
  },
  created() {
    this.pageSize = document.body.clientWidth > 768 ? 10 : 5
    this.getStime()
    this.init()
    this.getMarketList()
    // this.shopCardListWithMe();
  },
  beforeUnmount() {
    // 解绑事件、停止刷新
  },
  methods: {
    // 购物卡列表
    // async shopCardListWithMe() {
    //   try {
    //     let params = {
    //       pageNo: 1,
    //       pageSize: 10
    //     };
    //     let res = await shopCardListWithMe(params);
    //     this.meShopCardList = res.data.records[0] || "";
    //   } catch (e) {
    //     console.log(e.message);
    //   }
    // },
    infoClick(v) {
      if (v.statusName != '盲盒在售') {
        let query = {
          nftNo: v.nftNo,
          nftId: v.nftId
        }
        this.$router.push({
          path: '/info',
          query: {
            info: encode(JSON.stringify(query))
          }
        })
      } else {
        let query = {
          boxId: v.boxId
        }
        this.$router.push({
          path: '/mysteryBoxInfo',
          query: {
            info: encode(JSON.stringify(query))
          }
        })
      }

      this.dialogVisible = false
    },
    sortChange(index) {
      this.conSort = index
      this.pageNo = 1
      this.pageSize = 10
      this.getNumberList()
    },
    changeSelection(scope) {
      let mark = scope
      let i = scope.$index
      for (let index in this.directionOption) {
        let aa = this.directionOption[index]
        let value = aa.value
        if (mark === value) {
          this.$refs[`select${i}`].$el.children[0].children[0].setAttribute(
            'style',
            'background:url(' +
            aa.img +
            ') no-repeat;color:rgba(112, 112, 112, 1);padding-left:40px;text-indent: -9999px;background-position: left center;background-size: 40px 40px'
          )
        }
      }
    },
    copyLink() {
      let userVO = localStorage.getItem('userVO')
      let inviteCode = ''
      if (userVO) {
        inviteCode = JSON.parse(userVO).inviteCode
      } else {
      }
      let text = location.origin + '/info?info='

      let query = {
        nftId: this.info.nftId,
        inviteCode: inviteCode,
        nftNo: ''
      }

      if (this.info.isCopy === 1) {
        query.nftNo = this.info.nftNumberVO.nftNo
      }
      text += encode(JSON.stringify(query))
      const input = document.getElementById('input')
      input.value = text
      input.select()
      console.log(text)
      document.execCommand('copy')
      this.$message({
        type: 'success',
        message: '复制成功'
      })
    },
    changeShareDialogVisible() {
      let shareDialogVisible = this.shareDialogVisible
      this.shareDialogVisible = !shareDialogVisible
    },
    getStime() {
      getSysTime().then(res => {
        this.systemTime = Math.floor(
          new Date(res.data).getTime(res.data) / 1000
        )
      })
    },
    getNumber() {
      this.dialogVisible = true
    },
    getNumberList(flag) {
      let query = {
        nftId: this.info.nftId,
        condition: this.condition,
        nftNo: this.nftNo,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        conSort: this.conSort
      }
      nftNumberList(query).then(res => {
        if (res.data.totalCount == 0 && flag) {
          this.condition = ''
          this.getNumberList()
        }
        this.tableData = res.data.records
        this.totalCount = res.data.totalCount
        console.log(res.data.records)
      })
    },
    prevClick(val) {
      this.pageNo = val
      this.getNumberList()
    },
    nextClick(val) {
      this.pageNo = val
      this.getNumberList()
    },
    currentChange(val) {
      this.pageNo = val
      this.getNumberList()
    },
    numberInfo(id) {
      let query = {
        nftNo: id,
        nftId: this.info.nftId
      }
      this.$router.push({
        path: '/info',
        query: {
          info: encode(JSON.stringify(query))
        }
      })
      this.dialogVisible = false
    },

    // getNftNumberDetail (id) {
    //   nftNumberDetail({numberId: id}).then((res) => {
    //     this.info.nftNumberVO = res.data
    //     this.info.price = res.data.price
    //   })
    // },
    handleClose() {
      this.dialogVisible = false
    },
    copyAddress() {
      const text = this.info.contractAddress
      const input = document.getElementById('input')
      input.value = text
      input.select()
      console.log(text)
      document.execCommand('copy')
      this.$message({
        type: 'success',
        message: '复制成功'
      })
    },
    playVideo() { },
    canplayVideo() { },
    pauseVideo() { },
    copyNumber() {
      const text = this.info.receipt.blockNumber
      const input = document.getElementById('input')
      input.value = text
      input.select()
      console.log(text)
      document.execCommand('copy')
      this.$message({
        type: 'success',
        message: '复制成功'
      })
    },
    spanOmit(s) {
      if (s && s.length > 10) {
        return s.substr(0, 5) + '...' + s.substr(s.length - 5, s.length - 1)
      } else {
        return s
      }
    },
    scanClick(hash) {
      let url = 'https://scan.coopunion.net/tx/' + hash + '/token-transfers'
      window.open(url)
    },
    // 购买方式变换
    directionOptionChange() {
      let directionOption = this.directionOption
      let info = this.info
      if (info.nftNumberVO.consignmentNo || info.userType === 0) {
        directionOption[2].disabled = true
      }
      if (info.nftNumberVO.price >= 50000) {
        directionOption[1].disabled = true
        directionOption[2].disabled = true
        directionOption[3].disabled = true
      }
      this.directionOption = directionOption
    },
    init() {
      let myQuery = JSON.parse(decode(this.$route.query.info))
      console.log(myQuery)
      if (myQuery) {
        let query = {
          nftId: myQuery.nftId,
          isCopy: myQuery.isCopy,
          nftNo: myQuery.nftNo
        }
        if (query.nftNo) {
          // marketDetailNum
          marketDetailNum(query).then(res => {
            this.info = res.data
            if (this.info.nftType == 2) {
              this.onSell = false
            }
            // if (this.$route.query.numberId) {
            //   this.getNftNumberDetail(this.$route.query.numberId)
            // }
            if (res.data.isCopy === 1) {
              this.getNumberList(true)
            }
            this.info.createTime = timeChange(res.data.createTime)
            if (res.data.buyTime) {
              this.buyTime = Math.floor(new Date(res.data.buyTime) / 1000)
              this.getTime()
            }

            let videoOptions = this.playerOptions
            this.nftType = getDicType(res.data.picture)
            videoOptions.sources = [
              { type: this.nftType + '/mp4', src: res.data.picture }
            ]
            videoOptions.poster = res.data.coverPicture
            this.playerOptions = videoOptions

            console.log(this.playerOptions)
            this.directionOptionChange()
            this.onLoad()
          })
        } else {
          marketDetail(query).then(res => {
            this.info = res.data
            this.directionOptionChange()
            if (this.info.nftType == 2) {
              this.onSell = false
            }
            // if (this.$route.query.numberId) {
            //   this.getNftNumberDetail(this.$route.query.numberId)
            // }
            console.log(res.data)
            if (res.data.isCopy === 1) {
              this.getNumberList(true)
            }
            this.info.createTime = timeChange(res.data.createTime)
            if (res.data.buyTime) {
              this.buyTime = Math.floor(new Date(res.data.buyTime) / 1000)
              this.getTime()
            }
            this.nftType = getDicType(res.data.picture)
            let videoOptions = this.playerOptions
            console.log(videoOptions)

            videoOptions.sources = [
              { type: this.nftType + '/mp4', src: res.data.picture }
            ]
            videoOptions.poster = res.data.coverPicture
            this.playerOptions = videoOptions

            console.log(this.playerOptions)
            this.onLoad()
          })
        }
      }
      console.log(this.playerOptions)
    },
    getTime() {
      const openTime = this.buyTime
      if (openTime < this.systemTime) {
        return false
      }
      this.interval = setTimeout(() => {
        const openTimestamp = Math.floor(new Date(openTime).getTime())
        const nowDate = this.systemTime
        this.d = Math.floor((openTimestamp - nowDate) / 24 / 3600)
        this.h = Math.floor(
          (openTimestamp - nowDate - this.d * 24 * 3600) / 3600
        )
        this.m = Math.floor(
          (openTimestamp - nowDate - this.d * 24 * 3600 - this.h * 3600) / 60
        )
        this.s = Math.floor(
          openTimestamp -
          nowDate -
          this.d * 24 * 3600 -
          this.h * 3600 -
          this.m * 60
        )
        if (openTimestamp - nowDate <= 0) {
        } else {
          this.systemTime++
          this.getTime()
        }
      }, 1000)
    },
    routeClick(path, query) {
      this.$router.push({
        path: path,
        query: query
      })
    },
    isnumber(val) {
      val = val.replace(/[^0-9]/gi, '')
      // 此处还可以限制位数以及大小
      return val
    },
    getMarketList() {
      // 热门商品
      let query = {
        recommendType: '3',
        pageNo: 1,
        pageSize: 3
      }
      marketList(query).then(res => {
        this.hotData = res.data.records
      })
    },
    strictComputed(a, b) {
      let num = Decimal(a).mul(Decimal(b))
      return Decimal(a).sub(Decimal(num))
    },
    pay() {
      let query = {
        nftId: JSON.parse(decode(this.$route.query.info)).nftId,
        isCopy: this.info.isCopy,
        nftNo: this.info.nftNumberVO.nftNo,
        price: this.info.nftNumberVO.price,
        type: this.payType
        // cardId: this.meShopCardList.cardId || "",
        // discountPrice: this.strictComputed(
        //   this.info.price,
        //   this.meShopCardList.cardRebate
        // ),
        // isSetPW: this.meShopCardList.isSetPassword,
        // balance: this.meShopCardList.balance
      }
      this.$router.push({
        path: '/payConfirm',
        query: {
          info: encode(JSON.stringify(query))
        }
      })
    },
    compose() {
      this.$router.push({
        path: '/composeMarket'
      })
    },
    onLoad() { }
  }
}
</script>

<style lang="scss" scoped>
.index-container {
  max-width: 1200px;
  min-height: 269px;
  margin: 0 auto;

  @media screen and(max-width:768px) {
    width: 100%;
    padding: 0 12px;
  }

  .good {
    // @extend .flex-between-start;
    margin-top: 45px;

    @media screen and(max-width:768px) {
      flex-direction: column;
    }

    .picture {
      // @extend .flex-center-center;
      width: 568px;
      height: 634px;
      position: relative;
      padding: 20px;

      @media screen and(max-width:768px) {
        width: 100%;
        height: auto;
        padding: 0;
        border: 0;
      }

      .phone {
        display: none;

        @media screen and(max-width:768px) {
          width: 100%;
          height: auto;
          display: block;
        }
      }

      .PC {
        display: block;
        display: flex;
        justify-content: center;
        align-items: center;

        @media screen and(max-width:768px) {
          width: 100%;
          height: auto;
          display: none;
        }
      }

      .open {
        width: 20px;
        position: absolute;
        right: 15px;
        top: 15px;
        cursor: pointer;
      }

      border-radius: 6px;
      border: 1px solid #b4b4b4;

      .el-image {
        width: 474px;
        height: 540px;

        @media screen and(max-width:768px) {
          width: 100%;
          height: 400px;
        }

        background: #1c1d1c;
        box-shadow: 0px 12px 43px 0px rgba(0, 0, 0, 0.07);
        border-radius: 6px;
      }

      video {
        width: 100%;
      }
    }

    .info {
      width: 540px;

      @media screen and(max-width:768px) {
        width: 100%;
        height: auto;
      }

      .name-div {
        .name {
          font-size: 34px;
          color: #434343;
          margin: 44px 0 18px 0;
          line-height: 48px;

          @media screen and(max-width:768px) {
            width: 100%;
            height: auto;
            font-size: 24px;
          }
        }

        .share {
          width: 18px;
          height: 18px;
          margin: 20px 0 0 0;
          cursor: pointer;
        }
      }

      .isCopy {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 14px;
        font-weight: 400;
        color: #606060;
        line-height: 20px;

        .check-number {
          margin: 0 0 0 10px;
          color: #e8721d;
          cursor: pointer;

          &:hover {
            text-decoration: underline;
          }
        }
      }

      .look {

        // @extend .flex-between-center;
        .left {

          // @extend .flex-start-center;
          img {
            width: 36px;
            height: 36px;
            border-radius: 50%;
            margin-right: 7px;
          }

          span {
            font-size: 14px;
            color: #788391;
          }
        }

        .right {

          // @extend .flex-start-start;
          // .item {
          //   margin-left: 35px;
          //   img {
          //     width: 16px;
          //     height: 13px;
          //   }
          //   span {
          //     font-size: 14px;
          //     color: #788391;
          //   }
          // }
          .price {
            display: none;

            @media screen and(max-width:768px) {
              display: none;
            }

            font-size: 14px;
            color: #434343;

            .price-icon {
              margin: 0 5px;
            }

            .price-num {
              font-size: 30px;
              color: #494949;
            }
          }
        }
      }

      .owner {
        // @extend .flex-between-center;
        margin: 32px 0;
        width: 100%;

        .left {

          // @extend .flex-between-center;
          @media screen and(max-width:768px) {
            width: 100%;
          }

          .item {
            // @extend .flex-start-start;
            cursor: pointer;
            width: 152px;

            @media screen and(max-width:768px) {
              width: 50%;
              height: auto;
            }

            img {
              width: 42px;
              height: 42px;
              border-radius: 50%;
              margin-right: 10px;
            }

            div {
              p {
                &:nth-child(1) {
                  font-size: 14px;
                  color: #788391;
                }

                &:nth-child(2) {
                  font-size: 14px;
                  color: #434343;
                }
              }
            }
          }
        }

        .price {
          display: block;

          @media screen and(max-width:768px) {
            display: none;
          }

          p {
            font-size: 14px;
            color: #434343;

            .price-icon {
              margin: 0 5px 0 16px;
            }

            .price-num {
              font-size: 36px;
              color: #434343;
              font-weight: 600;
            }
          }
        }
      }

      .platform {
        // @extend .flex-around-center;
        flex-direction: column;
        width: 540px;
        height: 255px;
        background: #f2f6fe;
        border-radius: 8px;
        padding: 10px 46px 10px 20px;

        @media screen and(max-width:768px) {
          width: 100%;
          height: 255px;
        }

        .item {
          // @extend .flex-between-center;
          width: 100%;

          >span {
            font-size: 14px;
            color: #8d8d8d;
          }

          >div {
            // @extend .flex-start-start;
            width: 150px;

            .copy {
              width: 12px;
              height: 12px;
              cursor: pointer;
              margin-left: 4px;
            }

            .logo {
              width: 28px;
              height: 27px;
            }

            span {
              font-size: 14px;
              color: #434343;
            }

            .address {
              width: 100px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              display: inline-block;
              color: #e8721d;
              cursor: pointer;
            }
          }

          .cun {
            // @extend .flex-start-center;
          }
        }
      }

      .pay {
        margin-top: 18px;

        // @extend .flex-between-center;
        @media screen and(max-width:768px) {
          flex-direction: column;
          align-items: flex-start;
        }

        .type {

          // @extend .flex-center-center;
          >span {
            font-size: 16px;
            color: #626c7b;
          }

          /deep/ .el-select {
            width: 172px;

            .el-input__inner {
              border: 0;
              background-color: #fcfaf8;
              height: 44px;
              font-size: 16px;
            }

            .el-textarea__inner {
              font-size: 16px;
              border: 0;
              background-color: #fcfaf8;
            }

            .el-input__icon {
              line-height: 44px;
            }
          }
        }

        .pay-div {
          display: flex;
          justify-content: flex-start;
          align-items: center;

          @media screen and(max-width:768px) {
            position: fixed;
            z-index: 2;
            bottom: 0;
            width: 100%;
            height: 60px;
            left: 0;
            background-color: #ffffff;
            box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.3);
            display: flex;
            justify-content: space-around;
            align-items: center;
          }

          .price-icon {
            display: none;

            @media screen and(max-width:768px) {
              display: block;
              font-size: 14px;
              font-weight: 500;
              color: #3a3a3a;
              line-height: 20px;

              .price-num {
                font-size: 20px;
                font-weight: 500;
                color: #3a3a3a;
                line-height: 28px;
              }
            }
          }

          .pay-btn {
            width: 142px;
            height: 40px;
            display: block;
            background: #e8721d;
            box-shadow: 0px 2px 23px 0px rgba(0, 0, 0, 0.09);
            border-radius: 8px;
            color: #fafbff;
            font-size: 18px;
            border: 0;
            cursor: pointer;

            @media screen and(max-width:768px) {
              margin: 0;
              width: 130px;
              height: 40px;
              border-radius: 0;
            }
          }

          .pay-btn-false {
            background-color: #c1c1c1;
            cursor: auto;
          }

          .pay-other {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            width: 100%;
            height: 100%;

            @media screen and(max-width:768px) {
              width: auto;
            }
          }

          .djs {
            font-size: 14px;
            color: rgb(112, 112, 112);
            margin-right: 11px;

            @media screen and(max-width:768px) {
              display: none;
            }
          }

          .pay-btn-cancel {
            // cursor: not-allowed;
          }
        }
      }
    }
  }

  .info {
    .title {
      color: #434343;
      font-size: 34px;
      margin: 58px 0 40px 0;
    }
  }

  .hotgoods {
    .title {

      // @extend .flex-between-center;
      p {
        color: #434343;
        font-size: 34px;
        margin: 58px 0 40px 0;
      }

      .el-icon-arrow-up {
        font-weight: bold;
        width: 23px;
        height: 11px;
        font-size: 20px;
      }
    }

    .goods {
      // @extend .flex-start-start;
      flex-wrap: wrap;

      /deep/ .item {
        &:not(:nth-child(3n)) {
          margin-right: 30px;
        }

        @media screen and(max-width:768px) {
          &:not(:nth-child(3n)) {
            margin-right: 0;
          }
        }
      }

      @media screen and(max-width:768px) {
        /deep/ .item {
          margin-bottom: 20px;
        }
      }
    }
  }

  .video-player {
    width: 474px;
    height: 540px;
    border-radius: 6px;
    overflow: hidden;

    @media screen and(max-width:768px) {
      width: 293px;
      height: 320px;
    }

    /deep/ .video-js {
      height: 100%;

      .vjs-icon-placeholder {
        width: 100%;
        height: 100%;
        display: block;
      }

      .vjs-big-play-button {
        font-size: 30px;

        @media screen and(max-width:768px) {
          font-size: 24px;
        }

        background-color: rgba($color: #000, $alpha: 0);
      }
    }
  }

  .number-dialog {
    /deep/ .selling {
      background-color: #e8721d;
      color: white;
      width: 62px;
      height: 22px;
      line-height: 22px;
      text-align: center;
      display: inline-block;
      border-radius: 2px;
      // margin-left:-18px;

    }

    /deep/ .grey-span {
      background-color: #D2D2D2;
    }

    /deep/ .red-span {
      background-color: #E04371;
    }

    /deep/ .purple-span {
      background-color: #7B3AA4;
    }

    /deep/ .show {
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }

    /deep/ .el-dialog__body {
      padding: 30px 70px;
    }

    .title {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #3c3c3c;
      line-height: 28px;
      margin-right: 20px;
    }

    /deep/ .condition {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 30px;
      padding: 30px 0;

      .left {
        .el-input {
          // margin-bottom: 40px;
          width: 202px;

          .el-input__inner {
            border: 1px solid #E4E4E4;
            background-color: #fff;
            height: 40px;
            font-size: 14px;
            color: black;
            border-radius: 20px;
          }

          .el-input__icon {
            line-height: 30px;
            color: black;
          }
        }

        .el-checkbox__input.is-checked+.el-checkbox__label {
          color: #e8721d;
        }

        .el-checkbox__input.is-checked .el-checkbox__inner,
        .el-checkbox__input.is-indeterminate .el-checkbox__inner {
          background-color: #e8721d;
          border-color: #e8721d;
        }
      }

      .right {
        .el-select {

          // width: 115px;
          // height: 40px;
          .el-select-dropdown {
            z-index: 3 !important;

            .el-select-dropdown__wrap {
              margin-bottom: 0;
            }
          }

          .el-input.is-focus .el-input__inner {
            border-color: #E8721D;

            &:focus {
              border-color: #E8721D;
            }
          }

          .el-input .el-input__inner:focus {
            border-color: #E8721D;
          }
        }

        .el-select__popper .el-select-dropdown__item.selected {
          color: #E8721D !important;
        }

        .el-select {
          height: 40px;
          width: 137px;

          .el-input {
            height: 40px;

            .el-input__inner {
              height: 40px;

              @media screen and(max-width:768px) {
                // border:0;
                width: 137px;
                text-align: end
              }
            }
          }
        }

        .el-select .el-input.is-focus .el-input__inner {
          width: 137px;
          height: 40px;
          border-radius: 4px;
          border: 1px solid #C2C2C2;

          @media screen and(max-width:768px) {
            border: 0;
            width: 137px;
          }

        }

        .el-select .el-input__inner:focus {
          border: 1px solid #C2C2C2;

          @media screen and(max-width:768px) {
            border: 0;
            width: 137px;
          }
        }

        .el-select-dropdown__item.selected {
          color: #EB8A43 !important;
        }

        .sort {
          width: 200px;
          height: 40px;
          background: #F7F2EE;
          border-radius: 20px;
          margin-left: 34px;
          padding: 0 4px;

          .item {
            font-size: 13px;
            font-weight: 400;
            color: #303133;
            line-height: 40px;
            padding: 9px 14px;
            border-radius: 20px;
            cursor: pointer;
          }

          .active {
            background-color: #E8721D;
            color: white;
          }
        }
      }
    }

    /deep/ .el-pagination {
      margin: 10px 0 0 0;

      button:hover {
        color: #e8721d;
      }
    }

    /deep/ .el-pager li.active {
      color: #e8721d;
    }

    /deep/ .el-pager li:hover {
      color: #e8721d;
    }
  }

  .number-dialog-phone {
    display: none;
    position: fixed;
    bottom: 0;

    .condition {
      display: flex;
      justify-content: space-around;
      align-items: flex-start;
      flex-direction: column;
      height: 100px;
      padding: 0;

      .right {
        .sort {
          margin-left: 0;
        }
      }
    }

    @media screen and(max-width:768px) {
      display: block;
    }

    /deep/ .el-dialog__body {
      padding: 10px 20px;
    }

    /deep/ .table {
      .item {
        border-bottom: 1px solid #efefef;
        padding: 10px 0;
      }
    }
  }

  .number-dialog-pc {
    display: block;

    @media screen and(max-width:768px) {
      display: none;
    }
  }
}
</style>
<style lang="scss">
.payType0 {
  background: url("../../assets/images/icon/zfbpay-icon.jpg");
  background-size: 24px 24px;
}

.payType1 {
  background: url("../../assets/images/icon/fpay-icon.png");
  background-size: 20px 26px;
}

.payType2 {
  background: url("../../assets/images/icon/bank-icon.png");
  background-size: 20px 26px;
}

.payType3 {
  background: url("../../assets/images/icon/yjkj-icon.png");
  background-size: 20px 26px;
  background-position-y: 4px !important;
}

.payType4 {
  background: url("../../assets/images/setting/shopCardIcon.png");
  background-size: 20px 20px;
}

.payType0,
.payType1,
.payType2,
.payType3,
.payType4 {
  background-position-x: 12px;
  background-position-y: 5px;

  background-repeat: no-repeat;
  margin: 0 12px;

  span {
    margin-left: 22px;
    color: rgba(112, 112, 112, 1);
    font-size: 14px;
  }

  &:hover {
    background-color: #fcfaf8;
  }
}

.payType4 {
  background-position-y: 7px;
}

#payType-0 {
  background: url("../../assets/images/icon/zfbpay-icon.jpg");
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position: 8px center;
  padding: 0 0 0 35px;
}

#payType-1 {
  background: url("../../assets/images/icon/fpay-icon.png");
  background-size: 20px 26px;
  background-repeat: no-repeat;
  background-position: 8px center;
  padding: 0 0 0 35px;
}

#payType-2 {
  background: url("../../assets/images/icon/bank-icon.png");
  background-size: 20px 26px;
  background-repeat: no-repeat;
  background-position: 8px center;
  padding: 0 0 0 35px;
}

#payType-3 {
  background: url("../../assets/images/icon/yjkj-icon.png");
  background-size: 20px 26px;
  background-repeat: no-repeat;
  background-position: 8px center;
  padding: 0 0 0 35px;
}

#payType-4 {
  background: url("../../assets/images/setting/shopCardIcon.png");
  background-size: 20px 20px;
  background-repeat: no-repeat;
  background-position: 8px center;
  padding: 0 0 0 35px;
}
</style>



// WEBPACK FOOTER //
// src/views/info/index.vue